module.exports = __webpack_public_path__ + "static/media/importFlybook2.0d7e2470.png";